import { useState } from 'react';
import {
  ImageGallery,
  SendSignUpModal,
  SendSignUpSuccessModal,
  fullScreenButtonClick,
} from '../../design-system';
import { MobileNavigation, Navigation } from './Navigation';
import {
  MarketplacePage,
  MarketplaceHeader,
  MarketplaceBody,
  MarketplaceWrapper,
} from './MarketplaceComponents';
import { useIsSmallScreen } from '../../hooks';

export const MarketplaceClientYard = () => {
  const isSmallScreen = useIsSmallScreen();
  const [totalCount, setTotalCount] = useState(0);
  const [images, setImages] = useState<any>([]);

  const handleClickImage = (images: any[]) => {
    setImages(images.map(({ url }) => url));
    fullScreenButtonClick();
  };

  return (
    <>
      <MarketplaceWrapper>
        {!isSmallScreen && <Navigation />}
        {isSmallScreen && <MobileNavigation />}
        <MarketplacePage innerScroll>
          <MarketplaceHeader totalCount={totalCount} />
          <MarketplaceBody setTotalCount={setTotalCount} handleClickImage={handleClickImage} />
        </MarketplacePage>
      </MarketplaceWrapper>
      <ImageGallery photos={images} startIndex={0} />
      <SendSignUpModal />
      <SendSignUpSuccessModal />
    </>
  );
};
